import { render, staticRenderFns } from "./notsignedin-forcechangepassword.vue?vue&type=template&id=33b4d09e&scoped=true"
import script from "./notsignedin-forcechangepassword.vue?vue&type=script&lang=js"
export * from "./notsignedin-forcechangepassword.vue?vue&type=script&lang=js"
import style0 from "./notsignedin-forcechangepassword.vue?vue&type=style&index=0&id=33b4d09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4d09e",
  null
  
)

export default component.exports